import { FormattedMessage } from '@godaddy/react-mintl';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { golf, eids } from './enums';
import Link from '@ux/link';
import ChevronLeft from '@ux/icon/chevron-left';
import { cookie } from '@ux/util';

export default function HubBanner(props) {
  const [pcx, setPcx] = useState(false);

  useEffect(() => {
    try {
      const infoIDP = decodeURIComponent(cookie.get('info_idp'));
      const parsedPCX = JSON.parse(infoIDP).pcx;
      setPcx(parsedPCX);
    } catch (err) {
      // fail silently
    }
  }, []);

  return pcx ? (
    <div className='hub-banner'>
      <Link
        data-eid={ eids.proHub }
        href={ props.href }>
        <ChevronLeft />
        <FormattedMessage id={ golf.proHub } />
      </Link>
    </div>
  ) : null;
}

HubBanner.propTypes = {
  href: PropTypes.string.isRequired
};
